/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// React Router components
import { Link } from "react-router";
import { Trans, useTranslation } from "react-i18next";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import getLocalizedLinks from "common/localizedLinks";

// Authentication layout components
import BasicLayout from "../components/BasicLayout";

import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function NotSignedIn() {
  const { login, register } = useKindeAuth();
  const { t, i18n } = useTranslation("common");
  const { privacyPolicy, termsOfService } = getLocalizedLinks(i18n.resolvedLanguage);

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {t("signIn")}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox mt={4} mb={1}>
            <MDButton variant="gradient" color="info" fullWidth onClick={login}>
              {t("signIn")}
            </MDButton>
          </MDBox>
          <MDBox mt={2} mb={1} textAlign="center">
            <MDTypography variant="caption" color="text">
              <Trans
                t={t}
                i18nKey="legalConsent"
                components={{
                  privacyPolicy: (
                    <MDTypography
                      component="a"
                      href={privacyPolicy}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="caption"
                      color="info"
                      fontWeight="medium"
                      sx={{ whiteSpace: "nowrap" }}
                    />
                  ),
                  termsOfService: (
                    <MDTypography
                      component="a"
                      href={termsOfService}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="caption"
                      color="info"
                      fontWeight="medium"
                      sx={{ whiteSpace: "nowrap" }}
                    />
                  ),
                }}
              />
            </MDTypography>
          </MDBox>
          <MDBox mt={3} mb={1} textAlign="center">
            <MDTypography variant="button" color="text">
              {t("noAccount")}{" "}
              <MDTypography
                component={Link}
                onClick={register}
                to=""
                variant="button"
                color="info"
                fontWeight="medium"
                textGradient
              >
                {t("signUp")}
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default NotSignedIn;
